export default "__VITE_ASSET__W$W3JCZ7__"